import _ from "lodash";

import { IFormlyConfig, ITypeOptions } from "AngularFormly";
export * from "./controller";
import { UserAuthController } from "./controller";

export const vsTypeName = "userAuthSelect";
export const vsGridTypeName = `${vsTypeName}Grid`;

export function userSelectConfig(formlyConfigProvider: IFormlyConfig) {
  const gridType: ITypeOptions = {
    name: vsGridTypeName,
    wrapper: ["bootstrapHasError"],
    template: require("!html-loader!./index.html").default,
    controller: UserAuthController,
  };
  formlyConfigProvider.setType(gridType);

  const type: ITypeOptions = {
    ...gridType,
    name: vsTypeName,
    wrapper: ["bootstrapLabel", "bootstrapHasError"],
  };
  formlyConfigProvider.setType(type);
}
userSelectConfig.$inject = ["formlyConfigProvider"];
